import React, { useState, useEffect, useCallback } from 'react'
import { useForm } from "react-hook-form"
import './switch.css'

export default function Messsage () {
  const [tokenLoading, setTokenLoading] = useState(true)
  const [tokenGranted, setTokenGranted] = useState(false)
  const [tokenUsed, setTokenUsed] = useState(false)
  const [token, setToken] = useState(JSON.parse(sessionStorage.getItem('messagingToken')))
  const { register, handleSubmit } = useForm()

  const api_url = 'api.kubernaughty.com/turtlecom'

  const pullToken = useCallback(() => {
    const handlePull = response => {
      setToken(response.token)
      sessionStorage.setItem('messagingToken', JSON.stringify(response.token));
      if (response.granted) {
        activateToken()
      } else if (!response.granted) {
        expireToken()
      }
    }

    fetch(`https://${api_url}/auth/tokens`)
      .then(res => res.json())
      .then(res => handlePull(res));
  }, [])

  const activateToken = () => {
    setTokenLoading(false)
    setTokenGranted(true)
  }

  const expireToken = () => {
    setTokenLoading(false)
    setTokenGranted(false)
    setTokenUsed(true)
  }

  const onSubmit = (data) => {
    if (data.name === "") delete data.name
    console.log(data);

    fetch(`https://${api_url}/messaging/messages?token=${token.data}`, {
      method: 'post',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(sessionStorage.removeItem('messagingToken'))
    .then(() => {
      pullToken()
      setTokenUsed(true)
      expireToken()
    })
  }

  useEffect(() => {
    const checkValid = () => {
      if (token.exp > Math.round(Date.now() / 1000)) {
        return true;
      } else return false;
    }
    
    if (token === null || !checkValid()) {
      pullToken()
    } else if ('used' in token) {
      expireToken()
    } else {
      activateToken()
    }
  }, [pullToken, token])

  return (
    <div className="content">
      {tokenLoading && <h2>Loading Token...</h2>}
      {tokenGranted &&
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row gtr-uniform">
            <div className="col-6 col-12-xsmall">
              <input 
                type="text"
                name="name"
                id="name"
                placeholder="Name (optional)"
                maxLength='15'
                {...register('name', {maxLength: 15})} />
            </div>
            <div className="col-12">
              <textarea
                name="message"
                id="message"
                placeholder="Enter your message here"
                rows="3"
                maxLength='75'
                {...register('message', {maxLength: 75})} >
              </textarea>
            </div>
            <div className="col-12">
              <ul className="actions">
                <li><input type="submit" value="Submit" className="primary" /></li>
              </ul>
            </div>
          </div>
        </form>
      }
      {tokenUsed && <h3>You've submitted a message!  Try again in {token.exp - (Math.round(Date.now() / 1000))} seconds.</h3>}
    </div>
  )
}